import { useContext } from "react";
import UserService from "./UserService.js"
import { Context } from "../context/context.js";
import { Outlet } from "react-router-dom";
import UnauthorizedPage from "../components/error/UnauthorizedPage.js";
import InstituteNotEnabledPage from "../components/error/InstituteNotEnabledPage.js";
import Layout from "../components/layout/Layout.js";

function ProtectedRoute({ allowedRoles }) {
    const [{ user },] = useContext(Context);

    const checkAuth = () => {
        let isInstituteEnabled = UserService.isInstituteEnabled();

        if (!isInstituteEnabled) {
            return <InstituteNotEnabledPage />;
        }

        let isAuthorized = user.roles.some(r => allowedRoles.find(aR => aR === r.name));

        if (!isAuthorized) {
            return <UnauthorizedPage />;
        }

        return (
            <Layout>
                <Outlet />
            </Layout>
        );
    }

    return checkAuth();
};

export default ProtectedRoute
